import type { FC, ReactNode } from 'react'
import type { BlogPost } from '@/types'

import Link from 'next/link'

import { cn } from '@/lib/utils'

interface BlogCardProps {
    post: BlogPost
    big?: boolean
    linkClassName?: string
}

export const BlogCard: FC<BlogCardProps> = ({ post, big = false, linkClassName = 'blog-item-link' }): ReactNode => {
    return (
        <div className='blog-item mdl-dyn-item fade-in-move-on-scroll' role='listitem'>
            <Link href={`/insights/${post.slug}`} className={cn(linkClassName, 'mdl-inline-block')}>
                <div className={cn('blog-item-image-holder', big && 'blog-big-item-image-holder')}>
                    <img
                        className='blog-item-image'
                        src={post.thumbnail || post.mainImage}
                        loading='lazy'
                        alt={(post.thumbnail ? post.thumbnailAlt : post.mainImageAlt) || post.name}
                    />
                </div>
                <div className={cn('blog-item-content-holder', big && 'blog-big-item-content-holder')}>
                    <div className='blog-item-content grey-blog-item-content'>
                        <div className='blog-item-category'>
                            <div className='topic-text' data-mdlfy-cms={`blog_posts:${post.id}:topic`}>{post.topic}</div>
                            <div className='blog-item-date' data-mdlfy-cms={`blog_posts:${post.id}:date`}>{post.date}</div>
                        </div>
                        <h2 className='blog-item-title' data-mdlfy-cms={`blog_posts:${post.id}:name`}>{post.name}</h2>
                        <div className='blog-item-read-more-holder'>
                            <p className='blog-item-read-more'>Read More</p>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    )
}
